import React, { useEffect } from "react";
import { BiSearch } from "react-icons/bi";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
const SearchBarComponent = ({ query, setQuery, handleInputChangeDebounced }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const handleSearchClick = () => {
    if (location.pathname !== "/dashboard/users") {
      navigate("/dashboard/users");
    }
  };
  const handleChange = (e) => {
    const value = e.target.value;
    if (value) {
      searchParams.set("search_query", value);
    } else {
      searchParams.delete("search_query");
    }

    setSearchParams(searchParams);
  };
  useEffect(() => {
    const q = searchParams.get("search_query") || "";
    setQuery(q);
  }, [searchParams]);
  return (
    <div className="search" onClick={handleSearchClick}>
      <input
        type="text"
        placeholder="Search for Artists..."
        value={query}
        onChange={handleChange}
        // autoFocus={location.pathname === "/s"}
        autoFocus={location.pathname === "/dashboard/users"}
      />
      <BiSearch className="option-icon" />
    </div>
  );
};

export default SearchBarComponent;
